"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noValue = exports.yesValue = exports.yesNoInactiveColor = exports.RoundToggleWrappers = exports.yesNoIcons = exports.YesNoIcon = exports.yesNoDisplayFormats = void 0;
const color_1 = require("../color");
exports.yesNoDisplayFormats = [
    "checkmark",
    "heart",
    "thumbs_up",
    "flag",
    "star",
    "round_toggle",
    "rectangle_toggle",
    "yes_no_toggle",
];
exports.YesNoIcon = {
    checkmark: "checkmark-bigger",
    heart: "heart",
    thumbs_up: "thumbs-up",
    flag: "flag-straight",
    star: "star-fav",
};
exports.yesNoIcons = Object.keys(exports.YesNoIcon);
exports.RoundToggleWrappers = {
    filled: "filled",
    none: "",
};
exports.yesNoInactiveColor = color_1.Colors.bRed;
exports.yesValue = "yes";
exports.noValue = "no";
